import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollText } from 'lucide-react';

const SystemLogs = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">System Logs</h1>
        <p className="text-gray-600 mt-1">View application and system logs</p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <ScrollText className="w-5 h-5 text-gray-600" />
            <CardTitle>System Logs Viewer</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12 text-gray-500">
            <ScrollText className="w-12 h-12 mx-auto mb-4 text-gray-400" />
            <p>View and search system logs</p>
            <p className="text-sm mt-2">Backend integration pending</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SystemLogs;